import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import ImageSlider from "../../components/ImageSlider";

const ServiceDidPage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1100);
  const [isVisible, setIsVisible] = useState<boolean[]>([false]);
  const bannerImages = isMobile
    ? [
        {
          src: "https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webDidImage02-1.png",
        },
        {
          src: "https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webDidImage02-2.png",
        },
      ]
    : [
        {
          src: "https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webDidImage02-1.png",
        },
        {
          src: "https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webDidImage02-2.png",
        },
        {
          src: "https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webDidImage02-3.png",
        },
      ];

  // text 애니메이션
  const hideRefs = [
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;

      hideRefs.forEach((ref, index) => {
        const element = ref.current;
        if (element) {
          const elementTop = element.offsetTop;
          const elementHeight = element.offsetHeight;
          const isElementVisible =
            scrollTop + windowHeight > elementTop &&
            scrollTop < elementTop + elementHeight;
          setIsVisible((prev) => {
            const newVisible = [...prev];
            newVisible[index] = isElementVisible;
            return newVisible;
          });
        }
      });

      if (scrollTop + windowHeight === documentHeight) {
        setIsVisible((prev) => {
          const newVisible = [...prev];
          newVisible[newVisible.length - 1] = true;
          return newVisible;
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1100);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Style>
      <div className="wrap">
        <div className="bannerTitle mobileView">
          <h1
            ref={hideRefs[4]}
            className={` ${isVisible[4] ? "in_view fade_in" : "fade_in"}`}
          >
            DID
          </h1>
          <h2>저렴한 안드로이드 TV에 앱만 설치하면 끝!</h2>
        </div>
        <div className="banner">
          <img
            src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webDidImage01.png"
            alt="비하인드 DID"
            className="behindDid01"
          />
        </div>
        <div className="contentWrap">
          <div className="content">
            <h1
              ref={hideRefs[0]}
              className={` ${isVisible[0] ? "in_view fade_up" : "fade_up"}`}
            >
              메뉴보드
            </h1>
            <h2>DID 뿐만 아니라 메뉴판으로도 사용이 가능합니다.</h2>
            <ImageSlider images={bannerImages} />
          </div>
          <div className="content">
            <h1
              ref={hideRefs[1]}
              className={` ${isVisible[1] ? "in_view fade_up" : "fade_up"}`}
            >
              간편하고 저렴하게
            </h1>
            <h2>안드로이드 TV에 앱만 설치하면 끝!</h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webDidImage03.png"
              alt="간편하고 저렴한 비하인드 DID"
              className="behindDid03"
            />
          </div>
          <div className="content">
            <h1
              ref={hideRefs[2]}
              className={` ${isVisible[2] ? "in_view fade_up webView" : "fade_up webView"}`}
            >
              셋탑박스 NO! 앱 설치 하나면 끝!
            </h1>
            <h1
              ref={hideRefs[5]}
              className={` ${isVisible[5] ? "in_view fade_up mobileView" : "fade_up mobileView"}`}
            >
              셋탑박스 NO!<br /> 앱 설치 하나면 끝!
            </h1>
            <h2>
              셋탑박스 필요 없이 초저렴한 안드로이드 TV에
              <br />
              앱만 설치하면 이용 가능합니다.
            </h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webDidImage04.png"
              alt="설치가 간편한 DID"
              className="behindDid04"
            />
          </div>
          <div className="content">
            <h1
              ref={hideRefs[3]}
              className={` ${isVisible[3] ? "in_view fade_up" : "fade_up"}`}
            >
              메뉴 관리도 직접 가능
            </h1>
            <h2>메뉴 등록 및 수정이 관리페이지에서 가능합니다.</h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webDidImage05.png"
              alt="메뉴관리도 직접 수정, 관리 가능한 비하인드 DID"
              className="behindDid05"
            />
          </div>
        </div>
      </div>
    </Style>
  );
};

export default ServiceDidPage;
const Style = styled.div`
  h1,
  h2,
  h3,
  h4 {
    text-align: center;
  }
  h1 {
    font-size: 36px;
    font-weight: 700;
    line-height: 50px;
    color: #333;
  }
  h2 {
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    color: #979797;
  }
  h3 {
    font-size: 68px;
    font-weight: 700;
    line-height: 95px;
  }
  h4 {
    font-size: 36px;
    font-weight: 500;
    color: #979797;
    line-height: 50px;
  }

  /* wrap */
  .wrap {
    width: 100%;
    max-width: 100%;
    margin-top: 100px;

    img {
      width: 100%;
    }
  }

  /* banner */
  .banner {
    width: 100%;
  }

  /* contentWrap */
  .contentWrap {
    width: 100%;
    padding: 60px 30%;

    .content {
      padding: 120px 0;

      h1 {
        margin-bottom: 32px;
      }
      img {
        margin-top: 50px;
      }
    }
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;

    h1,
    img {
      margin: 0 !important;
    }
  }

  /* slide */
  .slide {
    width: 100%;
    display: flex;
    justify-content: center;
    img {
      width: 95%;
      height: auto;
    }
  }

  @media (max-width: 1100px) {
    h1 {
      font-size: 28px;
      font-weight: 700;
      line-height: 38px;
    }
    h2 {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }
    h3 {
      font-size: 32px;
      line-height: 44px;
    }
    h4 {
      font-size: 18px;
      line-height: 25px;
    }
    .wrap {
      margin-top: 70px;
    }
    .bannerTitle {
      h1 {
        font-size: 70px;
        line-height: 48px;
      }
      h2 {
        margin: 30px 0 40px 0;
        font-size: 16px;
        line-height: 25px;
      }
    }
    .contentWrap {
      padding: 40px 5vw;

      .content {
        padding: 40px 0;

        h1 {
          margin-bottom: 12px;
        }
        img {
          margin-top: 30px;
        }
      }
    }
    .footerContent {
      h3 {
        padding: 7px 5vw 30px 5vw;
      }
      h4 {
        margin-top: 0;
      }
    }

    /* 이미지 변경 */
    .behindDid01 {
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobileDidImage01.png");
    }
  }
`;
